import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgOtherProduct = function SvgOtherProduct(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_129_7648",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_129_7648)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1894E8",
        fillOpacity: 0.15,
        d: "M17.926 58.726a4.36 4.36 0 0 0 1.715 1.723l22.051 12.75a4.7 4.7 0 0 0 2.294.602q1.192 0 2.322-.602l22.051-12.75q1.123-.639 1.716-1.723a4.7 4.7 0 0 0 .592-2.29V31.564a4.7 4.7 0 0 0-.593-2.29 4.36 4.36 0 0 0-1.715-1.723l-22.051-12.75a4.7 4.7 0 0 0-2.294-.603q-1.192 0-2.322.603l-22.051 12.75a4.36 4.36 0 0 0-1.715 1.723 4.7 4.7 0 0 0-.593 2.29v24.872q0 1.204.593 2.29"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_129_7648)",
        d: "M38.718 66.846V40.711L15.898 27.52V52.5q0 .514.256.962.255.45.77.77zm2.564 0 21.795-12.615q.512-.32.77-.77.255-.449.256-.961v-25l-22.82 13.198zM40 38.576l22.551-13.108-21.525-12.449A2.3 2.3 0 0 0 40 12.763q-.513 0-1.026.256L17.43 25.468zM15.641 56.45q-1.123-.639-1.716-1.723a4.7 4.7 0 0 1-.592-2.29V27.564q0-1.205.592-2.29a4.36 4.36 0 0 1 1.716-1.723l22.051-12.75q1.13-.602 2.322-.602 1.191 0 2.294.602l22.051 12.75q1.123.639 1.716 1.723a4.7 4.7 0 0 1 .592 2.29v24.872a4.7 4.7 0 0 1-.593 2.29 4.36 4.36 0 0 1-1.715 1.723l-22.051 12.75q-1.13.602-2.322.602-1.191 0-2.294-.602z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_129_7648",
        x1: 13.89,
        x2: 65.924,
        y1: 39.999,
        y2: 39.999,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgOtherProduct as ReactComponent };
//# sourceMappingURL=OtherProduct.svg.es.js.map
